export default __webpack_public_path__ + "static/media/off.6184eb2d.png";